import React from 'react';
import { ArrowLeft, MoreVertical } from 'lucide-react';

const ChatHeader = ({ name, badge, avatarUrl, onBack, onMenu }) => {
    const initial = (name || 'U').toString().charAt(0).toUpperCase();

    return (
        <div className="chat-ui-header">
            <button
                type="button"
                className="chat-header-btn"
                onClick={onBack}
                aria-label="Back"
            >
                <ArrowLeft size={24} strokeWidth={2} />
            </button>

            <div className="chat-header-user">
                <div className="chat-header-avatar">
                    {avatarUrl ? (
                        <img src={avatarUrl} alt={name || 'User'} />
                    ) : (
                        <span>{initial}</span>
                    )}
                </div>
                <div className="chat-header-text">
                    <div className="chat-header-name">{name}</div>
                    {badge && <div className="chat-header-badge">{badge}</div>}
                </div>
            </div>

            <button
                type="button"
                className="chat-header-btn"
                onClick={onMenu || (() => {})}
                aria-label="More options"
            >
                <MoreVertical size={20} strokeWidth={2} />
            </button>
        </div>
    );
};

ChatHeader.defaultProps = {
    badge: null,
    avatarUrl: null,
    onBack: () => {},
    onMenu: () => {},
};

export default ChatHeader;

